import { render, staticRenderFns } from "./clientProfile.vue?vue&type=template&id=3a6a97a0&"
import script from "./clientProfile.vue?vue&type=script&lang=js&"
export * from "./clientProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports